import { defineStore } from "pinia"
import { computed } from "vue"
import { createResourceStore } from "./createResourceStore"
import type { Alert } from "@/types/resources"

export const useAlertsStore = defineStore("alerts", () => {
  const base = createResourceStore<Alert>({
    resource: "alerts",
    envelopeSingular: "alert",
    envelopePlural: "alerts",
    dexieTable: "alerts",
  })

  const activeCount = computed(
    () => base.items.value.filter((a) => !a.dismissed && !a.snoozed).length,
  )

  return { ...base, activeCount }
})
